import StandardQueryTable from "@/components/StandardQueryTable";
import DictionaryCreator from "@/components/dictionaries/DictionaryCreator";
import DictionaryEditor from "@/components/dictionaries/DictionaryEditor";
import { PATH_DICTS_SERVICES_AND_GOODS } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import {
  readServicesAndGoods,
  writeServicesAndGoods,
} from "@/schemas/servicesAndGoods";
import { ServicesAndGoodsService } from "@/services/servicesAndGoods";
import {
  ReadServicesAndGoods,
  WriteServicesAndGoods,
} from "@/types/servicesAndGoods";
import { Layers } from "lucide-react";

const id = Module.ServicesAndGoods;
const path = PATH_DICTS_SERVICES_AND_GOODS;
const ns = "servicesAndGoods";

const config: DictionaryConfig<ReadServicesAndGoods, WriteServicesAndGoods> = {
  id,
  ns,
  service: ServicesAndGoodsService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: writeServicesAndGoods,
  defaultValues: { name: "", invoice_description: "", code: "" },
  Icon: Layers,
  List: () => (
    <StandardQueryTable<ReadServicesAndGoods>
      schema={readServicesAndGoods}
      name={ns}
      fetchList={ServicesAndGoodsService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.ServicesAndGoods },
      }}
    />
  ),
  Creator: DictionaryCreator,
  Editor: DictionaryEditor,
};

export default config;
